import * as React from "react";
import { Table } from 'react-bootstrap';
import styled, { StyledFunction } from "styled-components";

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        font-size: 14px;
    }

    & > tbody > tr > td {
        font-size: 14px;
    }
`;

export const HeaderColumnWrapper = styled.th`
    :hover {
        cursor: pointer
    }
`;